module.exports = __webpack_public_path__ + "static/img/icon-quality.042f2b16.png";